import { loadingChunkRetry } from '@sit/client-shared';
import { lazy, Suspense } from 'react';
import { Outlet, useParams } from 'react-router';
import ErrorBoundary from '../../components/ErrorBoundary';
import DashboardContainer from '../DashboardContainer';
import { TimeEntryRefreshProvider } from './contexts/TimeEntryRefreshContext';
import { ErrorComponent } from './Error';
import PreviewComponent from './PreviewComponent';

const Timesheet = lazy(() => loadingChunkRetry(() => import('./Timesheet')));

const TimesheetContainer = () => {
  const { id: timesheetId } = useParams<{ id: string }>() as { id: string };

  return (
    <DashboardContainer showSecondaryNav={false}>
      <ErrorBoundary fallbackUI={(error) => <ErrorComponent error={error} />}>
        <Suspense fallback={<PreviewComponent />}>
          <TimeEntryRefreshProvider>
            <Outlet />
            <Timesheet key={timesheetId} timesheetId={timesheetId} />
          </TimeEntryRefreshProvider>
        </Suspense>
      </ErrorBoundary>
    </DashboardContainer>
  );
};

export default TimesheetContainer;
